import { useCallback, useContext, useMemo } from "react";

import manageStrings from "./manage-strings-helper";
import StringsContext from "./strings/strings-context";
import ConfigurationContext from "../app/configuration-context";

const useManagedStrings = (stringGroups) => {
  const strings = useContext(StringsContext);
  const configuration = useContext(ConfigurationContext);
  const managedStrings = useMemo(() => {
    const {verboseMissingStrings = false} = configuration ?? {};
    return manageStrings(strings, stringGroups, verboseMissingStrings)
  },  [
    strings,
    stringGroups,
    configuration
  ]);
  /*When we put managedStrings.someKey onto a tab's value, it can end up with duplicate
  tabs of the value "..." when configuration on a lane is not set to do verbose missing strings
  Depending on strings timing, that could result in a bug where the tabs start out all ..., then the translations
  come in and the tabs resolve to unique tab values, but the eden tabs still leave a stray ... tab around in those cases.
  This method exists to give places like that a way to guarantee a unique resolution for that key even when strings haven't loaded
  and verbose missing is false */
  const tabSafeLookup = useCallback((key) => {
    const fallback = `!${key}!`;
    try {
      const val = managedStrings[key];
      if (!val || val === "...") {
        return fallback;
      }
      return val;
    } catch (e) {
      return fallback;
    }

  },[managedStrings])

  return { strings, managedStrings, tabSafeLookup };
};

export default useManagedStrings;
